// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__12Kog","dragIcon":"SortableItem_dragIcon__1tuen","disabled":"SortableItem_disabled__1kIS_"};